<template>
  <div class="container">
    <!-- <div style="display: flex;gap: 0.2rem;">
      <van-button @click="onEat" type="info">吃</van-button>
      <van-button @click="onLying" type="info" style="margin: 0 10px;">爬</van-button>
      <van-button @click="onRun" type="info">跑</van-button>
      <van-button @click="onSitting" type="info">坐</van-button>
      <van-button @click="onStand" type="info">静态</van-button>
      <van-button @click="onStanding" type="info">站立</van-button>
      <van-button @click="onWalking" type="info">走</van-button>
    </div> -->
    <canvas ref="canvas" id="mainCanvas"></canvas>
  </div>
</template>

<script>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { RPC } from '@/api/rpc'
export default {
  name: 'ThreeScene',
  data() {
    return {
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      mixer: null,
      animationFrameId: null,
      sizes: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
      gltfObj: null,
      actions: null,
      gltf: '',
      machineId: '',
    }
  },
  mounted() {
    this.machineId = sessionStorage.getItem('deviceCode')?sessionStorage.getItem('deviceCode') : null
    console.log('aaaaaaaaa',this.machineId)
    this.getPetModel()
    // this.initLights()
  },
  beforeDestroy() {
    this.cleanup()
  },
  methods: {
    getPetModel() {
      RPC.getPetModel({machineId: this.machineId}).then(res=>{
        console.log('222',res)
        this.gltf = res.data.modelUrl
        this.initScene()
        this.loadModel()
      })
    },
    initScene() {
      // 获取Canvas元素
      const canvas = this.$refs.canvas

      // 初始化场景
      this.scene = new THREE.Scene()
      this.scene.background = null

      // 初始化相机
      this.camera = new THREE.PerspectiveCamera(
        100,
      //   this.sizes.width / this.sizes.height,
        0.8,
        0.1,
        1000
      )
      this.camera.position.set(5,1, 5); // 设置相机位置
      this.camera.lookAt(0, 0, 0);  

      // 初始化渲染器
      this.renderer = new THREE.WebGLRenderer({
        canvas,
        antialias: true,
        alpha: true
      })
      this.renderer.setSize(300, 500)
      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
      // this.renderer.shadowMap.enabled = true
      // this.renderer.shadowMap.type = THREE.PCFSoftShadowMap

      // 初始化控制器
      this.controls = new OrbitControls(this.camera, canvas)
      this.controls.enableDamping = true
      this.controls.zoomSpeed = 0.3
      // this.controls.enableZoom = false
      this.controls.target = new THREE.Vector3(0, 0, 0.7)
      // this.controls.autoRotate = true
    },
    switchAction(targetAction, duration = 0.3) {
      if (!this.mixer || !this.actions || !targetAction) return;
      // 取消所有正在进行的淡入淡出
      Object.values(this.actions).forEach(action => {
        action.stopFading();
      });
      
      // 平滑过渡到新动作
      Object.entries(this.actions).forEach(([name, action]) => {
        if (action === targetAction) {
          action
            .reset()
            .setEffectiveWeight(1)
            .fadeIn(duration)
            .play();
        } else {
          action.fadeOut(duration);
        }
      });
    },
    onEat() {
      this.switchAction(this.actions.eatting);
    },
    onLying() {
      this.switchAction(this.actions.lying);
    },
    onRun() {
      this.switchAction(this.actions.run);
    },
    onSitting() {
      this.switchAction(this.actions.sitting);
    },
    onStand() {
      this.switchAction(this.actions.stand);
    },
    onStanding() {
      this.$nextTick(()=>{
        this.switchAction(this.actions.standing);
      })
      
    },
    onWalking() {
      this.switchAction(this.actions.walking);
    },
    loadModel() {
      const gltfLoader = new GLTFLoader()
      const dracoLoader = new DRACOLoader()
      // dracoLoader.setDecoderPath('assets/draco/')
      // dracoLoader.preload()
      gltfLoader.setDRACOLoader(dracoLoader)

      const manager = new THREE.LoadingManager();
      manager.onProgress = (url, loaded, total) => {
        console.log(`加载进度: ${loaded}/${total}`);
      };
      gltfLoader.load(
        // 'assets/models/Fox/glTF/Fox.gltf',
        // 'https://h5.airpets.cn/models/Dog/dog3.gltf',
        // '/assets/models/Dog/dog3.gltf',
        this.gltf,
        (gltf) => {
          console.log('成功',gltf)
          let s = 4
          gltf.scene.scale.set(s, s, s)
          this.scene.add(gltf.scene)
          this.gltfObj = gltf

          const bbox = new THREE.Box3().setFromObject(gltf.scene);
          const center = bbox.getCenter(new THREE.Vector3());
          const size = bbox.getSize(new THREE.Vector3());
          gltf.scene.position.sub(center);

          this.initAnimationSystem(gltf);
          this.startAnimationWithMixer()
        },
        (progress) => {
          // console.log('progress', progress)
        },
        (error) => {
          console.log('error', error)
        }
      )
    },
    initAnimationSystem(gltf) {
      this.mixer = new THREE.AnimationMixer(gltf.scene);
      this.actions = {
          walking: this.mixer.clipAction(gltf.animations[6]),
          standing: this.mixer.clipAction(gltf.animations[5]),
          lying: this.mixer.clipAction(gltf.animations[1]),
          run: this.mixer.clipAction(gltf.animations[2]),
          sitting: this.mixer.clipAction(gltf.animations[3]),
          eatting: this.mixer.clipAction(gltf.animations[0]),
          stand: this.mixer.clipAction(gltf.animations[4]),
      };
      
      // 配置动画动作
      Object.values(this.actions).forEach(action => {
        action.setLoop(THREE.LoopRepeat);
        action.clampWhenFinished = true;
        action.play().setEffectiveWeight(0); // 预加载但初始权重为0
      });
      this.$emit('onDogReady',this.actions)
      // 默认显示survey动画
      this.actions.standing.setEffectiveWeight(1);
    },
    startAnimationWithMixer() {
      const clock = new THREE.Clock();
      let lastTime = 0;
      
      const animate = () => {
        const delta = Math.min(clock.getDelta(), 0.1);
        
        // 更新动画混合器
        if (this.mixer) {
          this.mixer.update(delta);
        }
        
        // 更新控制器和渲染
        this.controls.update();
        this.renderer.render(this.scene, this.camera);
        
        this.animationFrameId = requestAnimationFrame(animate);
      };
      
      animate();
    },
    initLights() {
      // // 方向光
      // const directionLight = new THREE.DirectionalLight()
      // directionLight.castShadow = true
      // directionLight.position.set(5, 5, 6)
      // directionLight.shadow.camera.near = 1
      // directionLight.shadow.camera.far = 20
      // directionLight.shadow.camera.top = 10
      // directionLight.shadow.camera.right = 10
      // directionLight.shadow.camera.bottom = -10
      // directionLight.shadow.camera.left = -10

      // // 方向光辅助
      // const directionLightHelper = new THREE.DirectionalLightHelper(directionLight, 2)
      // directionLightHelper.visible = false
      // this.scene.add(directionLightHelper)

      // // 阴影相机辅助
      // const directionalLightCameraHelper = new THREE.CameraHelper(directionLight.shadow.camera)
      // directionalLightCameraHelper.visible = false
      // this.scene.add(directionalLightCameraHelper)

      // // 环境光
      // const ambientLight = new THREE.AmbientLight(new THREE.Color('#ffffff'), 0.3)
      // this.scene.add(ambientLight, directionLight)
    },
    cleanup() {
      // 取消动画帧
      cancelAnimationFrame(this.animationFrameId)

      // 清理控制器
      if (this.controls) {
        this.controls.dispose()
      }

      // 清理渲染器
      if (this.renderer) {
        this.renderer.dispose()
      }

      // 清理场景中的对象
      if (this.scene) {
        while (this.scene.children.length > 0) {
          const object = this.scene.children[0]
          if (object.geometry) object.geometry.dispose()
          if (object.material) {
            if (Array.isArray(object.material)) {
              object.material.forEach(m => m.dispose())
            } else {
              object.material.dispose()
            }
          }
          this.scene.remove(object)
        }
      }
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#mainCanvas {
  display: block;
  width: 100%;
  height: 100%;
  /* border: 1px solid red; */
}
</style>